import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './WBKonfiguratorApp.vue';
import VTooltip from 'v-tooltip'

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
Vue.use(VueFormWizard)

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

// import {routes} from './routes';
// import {store} from './store/store';

window.Apps = window.Apps || {};
Apps.initWBKonfigurator = function (glassItemData, initialTranslations) {
    if ($('#wbkonfigurator-app-' + glassItemData.id).length > 0){

        Vue.use(VueRouter);
        Vue.use(VTooltip)
        const router = new VueRouter()
    //const router = new VueRouter({
    //  routes
    //});


    var data = {
      glassItemData,
      initialTranslations
    }
        new Vue({
            el: '#wbkonfigurator-app-' + glassItemData.id,
      data,
      router,
      // store,
      render: h => h(App)
    })
  }
}
